module.exports = __webpack_public_path__ + "img/user_icon.df99bdaa.png";